<template>
	<vs-popup v-if="!isMobile()"
		:title="employeeId != '' ? $t('EmployeeId') + ' ' + $t('UPDATE') : $t('EmployeeId') + ' ' + $t('AddNew')"
		button-cancel="border" @cancel="clearFields" @close="clearFields" :active.sync="isSidebarActiveLocal"
		classContent="popup-example" fullscreen> 
		<div>
			<b-row>
				<b-col cols="4">
					<vs-card>
						<form>
							<div class="vx-row">
								<div class="vx-col w-full">
									<b-tabs v-model="tabIndex" class="vs-input--label">

										<b-tab :title="$t('General')" active>
											<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new"
												:settings="settings" :key="$vs.rtl">
												<div class="pr-6 pt-6">
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group :label="'* ' + $t('EmployeeNo') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" v-model="employeeNo" name="employeeNo"
																v-validate="'required'" />
															<span class="text-danger text-sm" v-show="errors.has('employeeNo')">{{
																errors.first('employeeNo')
															}}</span>
														</b-col>
													</b-row>
													<b-row style="margin-top:8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="'* ' + $t('EmployeeName') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" v-model="employeeName" name="employeeName"
																v-validate="'required'" />
															<span class="text-danger text-sm" v-show="errors.has('employeeName')">{{
																errors.first('employeeName')
															}}</span>
														</b-col>
													</b-row>
													<b-row style="margin-top:8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="'* ' + $t('FisrtName') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" v-model="fisrtName" name="name"
																v-validate="'required'" />
															<span class="text-danger text-sm" v-show="errors.has('name')">{{
																errors.first('name')
															}}</span>
														</b-col>
													</b-row><b-row style="margin-top:8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="'* ' + $t('LastName') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" v-model="lastName" name="lastName"
																v-validate="'required'" />
															<span class="text-danger text-sm" v-show="errors.has('lastName')">{{
																errors.first('lastName')
															}}</span>
														</b-col>
													</b-row>
													<b-row style="margin-top:8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('GroupCode') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" v-model="groupGode" name="stock_name" />
														</b-col>
													</b-row>
													<b-row style="margin-top:8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('SpecCode1') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" v-model="specCode1" name="stock_name" />
														</b-col>
													</b-row>
													<b-row style="margin-top:8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('SpecCode2') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" v-model="specCode2" name="stock_name" />
														</b-col>
													</b-row>
													<b-row style="margin-top:8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('SpecCodeUnvan') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" v-model="specCodeUnvan" name="stock_name" />
														</b-col>
													</b-row>
													<b-row style="margin-top:8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('Description') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<vs-textarea v-model="description" />
														</b-col>
													</b-row>
												</div>

											</component>
										</b-tab>
										<b-tab :title="$t('Detail')">
											<component :is="scrollbarTag" ref="scroll" class="scroll-area--data-list-add-new"
												:settings="settings" :key="$vs.rtl">
												<div class="pr-6 pt-6">
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('web') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" type="text" v-model="web" name="stock_name" />
														</b-col>
													</b-row>
													<b-row style="margin-top:8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('Gsm') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" type="text" v-model="gsm" name="stock_name" />
														</b-col>
													</b-row>
													<b-row style="margin-top:8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('Email') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-input size="sm" id="h-first-name" type="text" v-model="email" name="stock_name" />
														</b-col>
													</b-row>
													<b-row style="margin-top: 8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('Status') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<v-select color="danger" v-model="status" :options="status_choices" size="small"
																label="text" autocomplete ref="selectElement">
															</v-select>
														</b-col>
													</b-row>
													<b-row style="margin-top: 8px">
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('CancelDate') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-datepicker id="baslangic" v-model="cancelDate" size="md" :locale="locale"
																class="mb-2" today-variant="danger" placeholder="-" :start-weekday="weekday"
																:date-format-options="{
																	year: 'numeric',
																	month: 'numeric',
																	day: 'numeric'
																}" />
														</b-col>
													</b-row>
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('EnteryDate') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-datepicker id="baslangic" v-model="enteryDate" size="md" :locale="locale"
																class="mb-2" today-variant="danger" placeholder="-" :start-weekday="weekday"
																:date-format-options="{
																	year: 'numeric',
																	month: 'numeric',
																	day: 'numeric'
																}" />
														</b-col>
													</b-row>
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('ExitDate') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<b-form-datepicker id="baslangic" v-model="exitDate" size="md" :locale="locale" class="mb-2"
																today-variant="danger" placeholder="-" :start-weekday="weekday" :date-format-options="{
																	year: 'numeric',
																	month: 'numeric',
																	day: 'numeric'
																}" />
														</b-col>
													</b-row>
													<b-row>
														<b-col cols="4" align-self="center">
															<b-form-group :label="$t('Note') + ' :'" label-for="h-first-name">
															</b-form-group>
														</b-col>
														<b-col cols="8">
															<vs-textarea v-model="note" />
														</b-col>
													</b-row>
												</div>
											</component>
										</b-tab>
									</b-tabs>


									<div class="items-center pr-6  mt-2 mb-0">
										<b-row align-h="end">
											<b-col cols="3" md="auto" style=" padding: 0px;">
												<b-button class="bg-danger" style=" border-color:white;" v-on:click="initValues">
													<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />
													{{
														$t('Cancel') }}
												</b-button>
											</b-col>
											<b-col cols="3" md="auto">
												<b-button class="bg-primary" style=" border-color:white;" v-on:click="addEmployee()">
													<Icon icon="material-symbols:save-outline" style="margin-right: 5px" width="20" height="20" />{{
														$t('Save') }}
												</b-button>
											</b-col>

										</b-row>
									</div>

								</div>
							</div>
						</form>
					</vs-card>
				</b-col>
				<b-col>
					<vs-card>
						<ag-grid-vue ref="agGridTable" class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
							:columnDefs="employeeColumns" :defaultColDef="defaultColDef" :rowData="employeeList" rowSelection="multiple"
							colResizeDefault="shift" :animateRows="true" :pagination="true" @grid-ready="onGridReady"
							:suppressCopyRowsToClipboard="true" :suppressPaginationPanel="true" :localeText="localeText">
						</ag-grid-vue>
					</vs-card>
				</b-col>
			</b-row>
		</div>
	</vs-popup>
	<vs-popup v-else :title="$t('EmployeeAddNew')" button-cancel="border" @cancel="clearFields" @close="clearFields"
		:active.sync="isSidebarActiveLocal" classContent="popup-example" fullscreen>
		<div>
			<b-row>
				<b-col cols="12">
					<vs-card>
						<form>
							<div class="vx-row">
								<div class="vx-col w-full">
									<b-tabs v-model="tabIndex" class="vs-input--label">

										<b-tab :title="$t('General')" active>

											<div class="p-6">
												<b-row>
													<b-col cols="4" align-self="center">
														<b-form-group :label="'* ' + $t('EmployeeNo') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" v-model="employeeNo" name="employeeNo"
															v-validate="'required'" />
														<span class="text-danger text-sm" v-show="errors.has('employeeNo')">{{
															errors.first('employeeNo')
														}}</span>
													</b-col>
												</b-row>
												<b-row style="margin-top:8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="'* ' + $t('EmployeeName') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" v-model="employeeName" name="employeeName"
															v-validate="'required'" />
														<span class="text-danger text-sm" v-show="errors.has('employeeName')">{{
															errors.first('employeeName')
														}}</span>
													</b-col>
												</b-row>
												<b-row style="margin-top:8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="'* ' + $t('FisrtName') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" v-model="fisrtName" name="name"
															v-validate="'required'" />
														<span class="text-danger text-sm" v-show="errors.has('name')">{{
															errors.first('name')
														}}</span>
													</b-col>
												</b-row><b-row style="margin-top:8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="'* ' + $t('LastName') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" v-model="lastName" name="lastName"
															v-validate="'required'" />
														<span class="text-danger text-sm" v-show="errors.has('lastName')">{{
															errors.first('lastName')
														}}</span>
													</b-col>
												</b-row>
												<b-row style="margin-top:8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('GroupCode') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" v-model="groupGode" name="stock_name" />
													</b-col>
												</b-row>
												<b-row style="margin-top:8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('SpecCode1') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" v-model="specCode1" name="stock_name" />
													</b-col>
												</b-row>
												<b-row style="margin-top:8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('SpecCode2') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" v-model="specCode2" name="stock_name" />
													</b-col>
												</b-row>
												<b-row style="margin-top:8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('SpecCodeUnvan') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" v-model="specCodeUnvan" name="stock_name" />
													</b-col>
												</b-row>
												<b-row style="margin-top:8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('Description') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<vs-textarea v-model="description" />
													</b-col>
												</b-row>
											</div>

										</b-tab>
										<b-tab :title="$t('Detail')">

											<div class="p-6">
												<b-row>
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('web') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" type="text" v-model="web" name="stock_name" />
													</b-col>
												</b-row>
												<b-row style="margin-top:8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('Gsm') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" type="text" v-model="gsm" name="stock_name" />
													</b-col>
												</b-row>
												<b-row style="margin-top:8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('Email') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-input size="sm" id="h-first-name" type="text" v-model="email" name="stock_name" />
													</b-col>
												</b-row>
												<b-row style="margin-top: 8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('Status') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<v-select color="danger" v-model="status" :options="status_choices" size="small" label="text"
															autocomplete ref="selectElement">
														</v-select>
													</b-col>
												</b-row>
												<b-row style="margin-top: 8px">
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('CancelDate') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-datepicker id="baslangic" v-model="cancelDate" size="md" :locale="locale" class="mb-2"
															today-variant="danger" placeholder="-" :start-weekday="weekday" :date-format-options="{
																year: 'numeric',
																month: 'numeric',
																day: 'numeric'
															}" />
													</b-col>
												</b-row>
												<b-row>
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('EnteryDate') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-datepicker id="baslangic" v-model="enteryDate" size="md" :locale="locale" class="mb-2"
															today-variant="danger" placeholder="-" :start-weekday="weekday" :date-format-options="{
																year: 'numeric',
																month: 'numeric',
																day: 'numeric'
															}" />
													</b-col>
												</b-row>
												<b-row>
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('ExitDate') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<b-form-datepicker id="baslangic" v-model="exitDate" size="md" :locale="locale" class="mb-2"
															today-variant="danger" placeholder="-" :start-weekday="weekday" :date-format-options="{
																year: 'numeric',
																month: 'numeric',
																day: 'numeric'
															}" />
													</b-col>
												</b-row>
												<b-row>
													<b-col cols="4" align-self="center">
														<b-form-group :label="$t('Note') + ' :'" label-for="h-first-name">
														</b-form-group>
													</b-col>
													<b-col cols="8">
														<vs-textarea v-model="note" />
													</b-col>
												</b-row>
											</div>
										</b-tab>
									</b-tabs>


									<div class="items-center pr-6  mt-2 mb-0">
										<b-row align-h="end">
											<b-col cols="3" md="auto" style=" padding: 0px;">
												<b-button class="bg-danger" style=" border-color:white;" v-on:click="initValues">
													<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />
													{{
														$t('Cancel') }}
												</b-button>
											</b-col>
											<b-col cols="3" md="auto">
												<b-button class="bg-primary" style=" border-color:white;" v-on:click="addEmployee()">
													<Icon icon="material-symbols:save-outline" style="margin-right: 5px" width="20" height="20" />{{
														$t('Save') }}
												</b-button>
											</b-col>

										</b-row>
									</div>

								</div>
							</div>
						</form>
					</vs-card>
				</b-col>
				<b-col>
					<vs-card>
						<ag-grid-vue ref="agGridTable" class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
							:columnDefs="employeeColumns" :defaultColDef="defaultColDef" :rowData="employeeList" rowSelection="multiple"
							colResizeDefault="shift" :animateRows="true" :pagination="true" @grid-ready="onGridReady"
							:suppressCopyRowsToClipboard="true" :suppressPaginationPanel="true" :localeText="localeText">
						</ag-grid-vue>
					</vs-card>
				</b-col>
			</b-row>
		</div>
	</vs-popup>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from "moment";
import { uuid } from "vue-uuid";
import { Icon } from "@iconify/vue2";
import vSelect from "vue-select";
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import { Validator } from "vee-validate";
import i18nData from "../../i18n/i18nData"
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import TextViewCellRenderer from "../CellRenderers/TextViewCellRenderer.vue";
import updateDeleteBtnCellRenderer from "../CellRenderers/updateDeleteBtnCellRenderer.vue";
export default {
	props: {
		isPromptActiveEmployee: {
			type: Boolean,
			required: true
		},
		data: {
			default: () => { }
		}
	},
	components: { VuePerfectScrollbar, updateDeleteBtnCellRenderer, TextViewCellRenderer, AgGridVue, DeleteWarning, Icon, "v-select": vSelect },
	watch: {
		isPromptActiveEmployee(val) {
			this.tabIndex = 0
			this.getEmployee(this.data.CompanyId)
			return val
		}
	},
	created() {
		this.locale = this.$i18n.locale == 'en' ? 'en-US' : this.$i18n.locale;
		const dict = {
			custom: {
				lastName: {
					required: this.$t('LastNameRequired'),
					alpha: this.$t('LastNameRequired')
				}, employeeName: {
					required: this.$t('EmployeeNameRequired'),
					alpha: this.$t('EmployeeNameRequired')
				}, employeeNo: {
					required: this.$t('EmployeeNoRequired'),
					alpha: this.$t('EmployeeNoRequired')
				}, name: {
					required: this.$t('FirstNameRequired'),
					alpha: this.$t('FirstNameRequired')
				}

			}
		};
		Validator.localize("en", dict);
	},
	data() {
		return {
			isMobile: function () {
				return isMobile;
			},
			settings: { // perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: .60
			},
			tabIndex: 0,
			employeeColumns: [],
			defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true
			},
			employeeList: [],
			weekday: 1,
			locale: "",
			updatedItem: [],
			deleteWarningPromptValid2: false,
			employeeId: "",
			employeeNo: "",
			employeeName: "",
			groupGode: "",
			specCode1: "",
			specCode2: "",
			status: 0,
			note: "",
			cancelDate: "",
			description: "",
			gsm: "",
			email: "",
			web: "",
			fisrtName: "",
			lastName: "",
			enteryDate: "",
			exitDate: "",
			specCodeUnvan: "",
			compnayId: "",
			status_choices: [{
				text: this.$t('Active'), value: 1
			}, {
				text: this.$t('Passive'), value: 0
			}],
		}
	},
	methods: {
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
		},
		editEmployee(item) {
			this.tabIndex = 0
			this.setDataValues(item);
		},
		closeDeleteWarning() {
			this.deleteWarningPromptValid2 = false
		},
		deleteEmployee(data) {
			const vs = this.$vs;
			this.$store
				.dispatch("customer/deleteEmployee", data.EmployeeId)
				.then(response => {
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center"
							});
							this.getEmployee(this.data.CompanyId);
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch(error => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});

		},
		parseDate(params) {
			return moment(String(params)).format("DD.MM.YYYY");
		},
		getEmployee(item) {
			const vs = this.$vs;
			this.employeeList = []
			this.employeeColumns = []
			this.$store.dispatch("customer/listEmployeeForCompany", item).then(response => {
				// let costumerList = JSON.parse(response.json);
				if (response.success == true) {
					this.employeeList = this.$store.state.customer.Employee;
					console.log(this.employeeList)
					if (this.employeeList.length > 0) {
						let columnList = Object.keys(this.employeeList[0]);
						this.employeeColumns.push({
							width: 100,
							pinned: "left",
							cellRendererFramework: "updateDeleteBtnCellRenderer",
							cellRendererParams: {
								addMethods: "addBarcodePopup",
								addIcon: "ph:barcode"
							}
						},)
						columnList.forEach((val, index) => {
							if (val.toString().includes("Date") == true) {
								this.employeeColumns.push({ cellRendererFramework: "TextViewCellRenderer", headerName: this.$t(val), field: val, filter: "agSetColumnFilter", valueFormatter: params => this.parseDate(params.data[val]) });
							} else if (val.toString().includes("Id") == true) {
							}
							else
								this.employeeColumns.push({ cellRendererFramework: "TextViewCellRenderer", headerName: this.$t(val), field: val, filter: "agSetColumnFilter" });


						});
					}

				} else
					console.log(response.statusText)
				/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
			});
		},

		addEmployee() {
			var createdId = uuid.v4();
			const vs = this.$vs;
			this.$validator.validateAll().then(result => {
				if (result) {
					const obj =
					{
						"employeeId": this.employeeId != "" ? this.employeeId : createdId,
						"employeeNo": this.employeeNo,
						"employeeName": this.employeeName,
						"groupGode": this.groupGode,
						"specCode1": this.specCode1,
						"specCode2": this.specCode2,
						"status": typeof this.status.value == "undefined" || this.status == "" ? 1 : this.status.value,
						"note": this.note,
						"cancelDate": this.cancelDate == "" ? null : this.cancelDate,
						"description": this.description,
						"gsm": this.gsm,
						"email": this.email,
						"web": this.web,
						"fisrtName": this.fisrtName,
						"lastName": this.lastName,
						"enteryDate": this.enteryDate == "" ? null : this.enteryDate,
						"exitDate": this.exitDate == "" ? null : this.exitDate,
						"specCodeUnvan": this.specCodeUnvan,
						"compnayId": this.data.CompanyId
					}

					if (this.employeeId != "") {

						this.$store.dispatch('customer/updateEmployee', obj).then(response => {
							if (response.status == 200) {
								vs.notify({
									text: response.data.message,
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "success",
									position: "top-center"
								});
								this.getEmployee(this.data.CompanyId);
								this.initValues()
							} else {
								vs.notify({
									text: response.data.message.toString(),
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "danger",
									position: "top-center",
								});
							}
						})
							.catch(error => {
								return new Promise((resolve, reject) => {
									resolve(false);
								});
							});
					} else {
						delete obj.id
						obj.popularity = 0
						this.$store.dispatch('customer/addEmployee', obj).then(response => {
							if (response.status == 200) {
								vs.notify({
									text: response.data.message,
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "success",
									position: "top-center"
								});
								this.getEmployee(this.data.CompanyId);
								this.initValues()
							} else {
								vs.notify({
									text: response.data.message.toString(),
									iconPack: "feather",
									icon: "icon-alert-circle",
									color: "danger",
									position: "top-center",
								});
							}
						})
							.catch(error => {
								return new Promise((resolve, reject) => {
									resolve(false);
								});
							});
					}

				} else {
					vs.notify({
						text: this.$t('Validate'),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center"
					});
				}
			})


		},

		setDataValues(item) {
			this.employeeId = item.EmployeeId;
			this.employeeNo = item.EmployeeNo;
			this.employeeName = item.EmployeeName;
			this.groupGode = item.GroupGode;
			this.specCode1 = item.SpecCode1;
			this.specCode2 = item.SpecCode2;
			this.status = [{ text: item.Status == 0 ? this.$t('Passive') : this.$t('Active'), value: this.data.Status }];
			this.note = item.Note;
			this.cancelDate = item.CancelDate;
			this.description = item.Description;
			this.gsm = item.Gsm;
			this.email = item.Email;
			this.web = item.Web;
			this.fisrtName = item.FisrtName;
			this.lastName = item.LastName;
			this.enteryDate = item.EnteryDate;
			this.exitDate = item.ExitDate;
			this.specCodeUnvan = item.SpecCodeUnvan;
			this.compnayId = item.CompnayId;
		},
		initValues() {
			this.employeeId = "";
			this.employeeNo = "";
			this.employeeName = "";
			this.groupGode = "";
			this.specCode1 = "";
			this.specCode2 = "";
			this.status = 0;
			this.note = "";
			this.cancelDate = "";
			this.description = "";
			this.gsm = "";
			this.email = "";
			this.web = "";
			this.fisrtName = "";
			this.lastName = "";
			this.enteryDate = "";
			this.exitDate = "";
			this.specCodeUnvan = "";
			this.compnayId = "";

		},
		clearFields() {
			this.storehouseDetailList = []
			this.$root.$emit("closeEmployeeData");
			this.employeeId = "";
			this.employeeNo = "";
			this.employeeName = "";
			this.groupGode = "";
			this.specCode1 = "";
			this.specCode2 = "";
			this.status = 0;
			this.note = "";
			this.cancelDate = "";
			this.description = "";
			this.gsm = "";
			this.email = "";
			this.web = "";
			this.fisrtName = "";
			this.lastName = "";
			this.enteryDate = "";
			this.exitDate = "";
			this.specCodeUnvan = "";
			this.compnayId = "";
		},
	},
	mounted() {

		this.$root.$on("deleteData2", (data) => {
			this.deleteData2 = data
			this.deleteCustomer(data);
		});
		this.$root.$on("editDataBtn", (data) => {
			this.editEmployee(data);
		});
		this.$root.$on("deleteDataBtn", (data) => {
			this.deleteEmployee(data);
		});

	},
	beforeDestroy() {
		this.$root.$off("deleteData2");
		this.$root.$off("editDataBtn");
		this.$root.$off("deleteDataBtn");
	},
	computed: {
		scrollbarTag() { return this.$store.getters.scrollbarTag },
		isSidebarActiveLocal: {
			get() {
				return this.isPromptActiveEmployee
			},
			set(val) {
				if (!val) {
					this.$emit('closeSidebar')
					// this.$validator.reset()
					// this.initValues()
				}
			}
		},

		localeText() {
			return i18nData[this.$i18n.locale];
		},
	}
}
</script>
<style lang="scss" scoped>
.vs-input--label {
	color: black;
	font-size: small;
}

.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 185px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.scroll-to-ag-grid-table {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 150px);

	&:not(.ps) {
		overflow-y: auto;
	}
}
</style>

 